import activities from "./tables/activities.json";
import activity_descriptions from "./tables/activity_descriptions.json";
import activity_rates from "./tables/activity_rates.json";
import allocations from "./tables/allocations.json";
import bank_accounts from "./tables/bank_accounts.json";
import bank_transactions from "./tables/bank_transactions.json";
import billable_clients from "./tables/billable_clients.json";
import billable_matters from "./tables/billable_matters.json";
import bills from "./tables/bills.json";

// this causes a 429 rate limit issue
// and we may not need notes for reporting...
// eslint-disable-next-line no-unused-vars
import contactNotes from "./tables/contactNotes.json";
// eslint-disable-next-line no-unused-vars
import matterNotes from "./tables/matterNotes.json";

import calendar_entries from "./tables/calendar_entries.json";

import contacts from "./tables/contacts.json";
import credit_memos from "./tables/credit_memos.json";
import custom_field_sets from "./tables/custom_field_sets.json";
import custom_fields from "./tables/custom_fields.json";
import expense_categories from "./tables/expense_categories.json";
import groups from "./tables/groups.json";
import interest_charges from "./tables/interest_charges.json";
import log_entries from "./tables/log_entries.json";
import matters from "./tables/matters.json";
import practice_areas from "./tables/practice_areas.json";
import relationships from "./tables/relationships.json";
import trust_line_items from "./tables/trust_line_items.json";
import line_items from "./tables/line_items.json";
import users from "./tables/users.json";
import tasks from "./tables/tasks.json";
import matter_stages from "./tables/matter_stages.json";
import matter_dockets from "./tables/matter_dockets.json";
import jurisdictions from "./tables/jurisdictions.json";
import documents from "./tables/documents.json";
import payments from "./tables/payments.json";

export const tables = {
  activities,
  activity_descriptions,
  activity_rates,
  allocations,
  bank_accounts,
  bank_transactions,
  billable_clients,
  billable_matters,
  bills,
  calendar_entries,
  contacts,
  credit_memos,
  custom_field_sets,
  custom_fields,
  documents,
  expense_categories,
  groups,
  interest_charges,
  jurisdictions,
  line_items,
  log_entries,
  matters,
  matter_stages,
  matter_dockets,
  payments,
  practice_areas,
  relationships,
  trust_line_items,
  users,
  tasks,
};

// to simplify testing
// eslint-disable-next-line no-unused-vars
const test = {
  bills,
};

const data = {
  tables: tables,
};

export default data;
